module.exports = __webpack_public_path__ + "img/d_v3.5e5b9ad.png";